// Definição para o modal de busca de Limites de Crédito
// Factory function - recebe filtros como parâmetros, sem magic strings

export const criarConfigBuscaLimiteCredito = (idOrganizacao, idInstituicaoFinanceira = null) => {
  const filtros = { idOrganizacao }
  if (idInstituicaoFinanceira) {
    filtros.idInstituicaoFinanceira = idInstituicaoFinanceira
  }

  return {
    label: 'Limite de Crédito',
    placeholder: 'ID ou Descrição...',
    titulo: 'Selecionar Limite de Crédito',
    endpointApi: 'LimitesCredito',
    idField: 'idLimiteCredito',
    displayField: 'idLimiteCredito',
    descField: 'descricao',
    tabela: 'LimiteCredito',
    camposFiltro: [
      { label: 'Descrição', model: 'busca', tipo: 'text' }
    ],
    colunasGrid: [
      { header: 'ID', dataField: 'idLimiteCredito', width: '8%' },
      { header: 'Banco', dataField: 'nomeInstituicaoFinanceira', width: '18%' },
      { header: 'Descrição', dataField: 'descricao', width: '24%' },
      { header: 'Moeda', dataField: 'lstMoeda', width: '10%' },
      {
        header: 'Valor Limite',
        dataField: 'valorAprovado',
        width: '20%',
        align: 'end',
        formatter: (value) => {
          if (value == null) return ''
          return Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
      },
      {
        header: 'Saldo Disponível',
        dataField: 'saldoDisponivel',
        width: '20%',
        align: 'end',
        formatter: (value) => {
          if (value == null) return ''
          return Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
      }
    ],
    filtrosFixos: filtros,
    // Formata o label informativo do CampoBusca como "Descrição / Limite 1.234,56 Dólar Americano"
    descFormatter: (item) => {
      if (!item) return ''
      const valorLimite = Number(item.valorAprovado).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      const moeda = item.lstMoedaTexto || item.lstMoeda || ''
      return `${item.descricao || ''} / Limite ${valorLimite} ${moeda}`
    }
  }
}
